module.exports = __webpack_public_path__ + "img/11.10892d96.png";